import React, { useReducer, createContext, useEffect, useState } from 'react'
import defaultState from '../data/index'
import SearchReducer from '../reducers/SearchReducer'
import fetchInitialData from '../helpers/fetchInitialData'

import { SET_ERROR, SET_LOADING, SET_DATA, SET_NEW_STATE, SET_NOT_PAGINATED_DATA, SET_NOT_PAGINATED_DATA_LOADING, SET_SEARCH_TERMS } from '../actions/actionTypes'
import setFilters from '../helpers/setFilters'
import search from '../helpers/search'
import urlBuilder from '../helpers/urlBuilder'
import awardsOptions from '../../util/awardsOptions'

export const SearchContext = createContext()

const SearchProvider = props => {
  const [state, dispatch] = useReducer(SearchReducer, defaultState)
  const [ isReady, setIsReady ] = useState(false)

  // eslint-disable-next-line
  const baseUrl = `${API_BASE_URL}`

   const getUserLocation = () =>
     new Promise((resolve, reject) => {
       if ("geolocation" in navigator) {
         navigator.geolocation.getCurrentPosition(
           (position) => {
             resolve({
               lat: position.coords.latitude,
               lng: position.coords.longitude,
             });
           },
           (error) => {
             reject(error);
           }
         );
       } else {
         reject("No navigator.geolocation available");
       }
     });

  const getData = () => fetchInitialData(baseUrl)
    .then(values => {
      const filtersList = {
        cuisines: values[0].data,
        ambiences: values[1].data,
        awards: awardsOptions(),
      }
      return setFilters(filtersList, dispatch, state, true)
    })
    .catch(e => {
      console.log(e)
      return dispatch({
        type: SET_LOADING,
        payload: {
          value: false,
        },
      })
    })

  useEffect(() => {
    // Check if the URL contains "terms" parameters, and if so, return early and do not use geolocation
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("terms")) {
      getData()
      return;
    }

    getData()
      .then(() => {
        getUserLocation()
          .then((location) => {
            dispatch({
              type: SET_SEARCH_TERMS,
              payload: {
                data: {
                  value: `${location.lat},${location.lng}`,
                  type: "location",
                },
              },
            });
          })
      })
      .catch(() => {
        getData();
      });

  }, [])


  useEffect(() => {
    search( baseUrl, state.selections, state.sorts, state.per_page, state.page, state.searchTerm, state.searchType )
      .then(response => {
        dispatch({
          type: SET_DATA,
          payload: {
            data: response.data.results,
            dataMeta: response.data.meta,
          },
        })
        urlBuilder(state)
      })
      .catch(e => {
        console.log(e)
      })
  }, [ state.selections,state.sorts, state.page, state.per_page, state.searchTerm, state.searchType, state.filters.clubOffers.anyMeal ])

  useEffect(() => {
    if (!state.searchByMoveActive || state.view !== 'map' ) {
      return
    }

    dispatch({
      type: SET_NOT_PAGINATED_DATA_LOADING,
      payload: {
        loading: true,
      },
    })

    search( baseUrl, state.selections, state.sorts, state.per_page, state.page, state.searchTerm, state.searchType, state.searchByMoveActive, state.radius, state.mapCenter)
      .then(response => {
        dispatch({
          type: SET_NOT_PAGINATED_DATA,
          payload: {
            data: response.data.results,
          },
        })
      })
      .catch(e => {
        console.log(e)
      })
  }, [ state.view, state.searchByMoveActive, state.radius, state.mapCenter ])

  return (
    <SearchContext.Provider value={[state, dispatch]}>
      {props.children}
    </SearchContext.Provider>
  )
}

export default SearchProvider
